import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Typography } from '@mui/material';
import React from 'react';

interface RequiredInfoErrorProps {
    label: string;
}

export const RequiredInfoError: React.FC<RequiredInfoErrorProps> = ({ label }: RequiredInfoErrorProps) => (
    <Typography sx={{ display: 'flex', columnGap: 1 }} color={themeColors.accent.red.bold} variant='subtitle2'>
        <ErrorOutlineIcon />
        {label}
    </Typography>
);
